/**
 * Module dependencies.
 */

import { AboutCompany } from 'components/molecules/about-company/about-company';
import { Company } from 'types/company';
import { Container } from 'components/atoms/container/container';
import { Footer } from 'components/molecules/footer/footer';
import { HomeCarousell } from 'components/molecules/home-carousel/home-carousel';
import { HomeGallery } from 'types/home-gallery';
import { JSX } from 'react';
import { ProductType } from 'types/product';
import { Products } from 'components/molecules/products/products';
import { ServiceType } from 'types/service';
import { Services } from 'components/molecules/services/services';

/**
 * `Props` type.
 */

type Props = {
  company: Company;
  homegallery: HomeGallery[];
  products: ProductType[];
  services: ServiceType[];
  socialNetworks: Record<string, string>;
};

/**
 * Export `Home` component.
 */

export default function Home(props: Props): JSX.Element {
  const { company, homegallery, products, services, socialNetworks } = props;

  return (
    <>
      <HomeCarousell homegallery={homegallery} />

      <Container>
        <Products products={products} />

        <AboutCompany company={company} />

        <Services services={services} />
      </Container>

      <Footer socialNetworks={socialNetworks} />
    </>
  );
}
